export const UPDATE_DETAILS = 'UPDATE_DETAILS';
export const SET_DIVA_OUTCOME = 'SET_DIVA_OUTCOME';

export const updateDetails = payload => ({
  type: UPDATE_DETAILS,
  payload,
});

export const setDivaOutcome = payload => ({
  type: SET_DIVA_OUTCOME,
  payload,
});
